import styled, { css } from 'styled-components';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';
import { WIDTH_MENU_HOST } from '@constants';
import { WrapperProps } from './BaseModalTypes';

interface BackdropPropsInterface {
  opacity?: number;
  backgroundColor?: string;
}

const menuHidedInResolution = dsTokens.breakpoint.md.maxWidth;

export const Container = styled.div<{ zIndex: number }>`
  ${({ zIndex }) => css`
    position: relative;
    z-index: ${zIndex || 999};
  `}
`;

export const OutsideArea = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

export const Backdrop = styled(OutsideArea)<BackdropPropsInterface>`
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor || theme.color.background.neutral.inverted};
  z-index: 990;
  transition-delay: 0.1s;
  transition: all 0.2s cubic-bezier(0.65, 0, 0.35, 1);
  opacity: 0;
  left: 0;

  &.animated {
    opacity: ${({ opacity }) => opacity || 0.4};
  }
`;

const vAlignmentMap = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
};

const hAlignmentMap = {
  left: 'start',
  center: 'center',
  right: 'end',
};

export const Wrapper = styled.div<WrapperProps>`
  position: fixed;
  left: 0;
  top: 0;
  width: calc(100% - ${WIDTH_MENU_HOST});
  height: 100vh;
  display: flex;
  justify-content: ${({ hAlignment = 'center' }) => hAlignmentMap[hAlignment]};
  align-items: ${({ vAlignment = 'center' }) => vAlignmentMap[vAlignment]};
  z-index: 999;
  overflow-y: auto;
  left: ${WIDTH_MENU_HOST};

  @media screen and (max-width: ${menuHidedInResolution}) {
    width: 100%;
    left: 0;
  }
`;

export const Stage = styled.div`
  z-index: 1;
`;
